export default __webpack_public_path__ + "static/media/solana.16cf0525.svg";